import { CdnImg } from '@/features/cdn-img';
import { useRouter } from '@/navigation';

import {
	WE88_SEASONAL_PROMOTION_ALT_TEXT,
	WE88_SEASONAL_PROMOTION_CTA_ROUTES,
	WE88_SEASONAL_PROMOTION_IMAGE_PATHS,
	type We88SeasonalPromotionVariant,
} from './constants';
import styles from './we88-seasonal-promotion-slider.module.scss';
import { useGoToWcPromotionMenuUrl } from '@/domains/wc-promotion/hooks/use-wc-promotion-menu-url';

interface We88SeasonalPromotionSliderProps {
	variant: We88SeasonalPromotionVariant;
	onClose: () => void;
}

export const We88SeasonalPromotionSlider = ({
	variant,
	onClose,
}: We88SeasonalPromotionSliderProps) => {
	const router = useRouter();
	const goToWcPromotionMenuUrl = useGoToWcPromotionMenuUrl();
	const handleClick = () => {
		if (variant === 'world-cup-fever') {
			goToWcPromotionMenuUrl();
		} else {
			router.push(WE88_SEASONAL_PROMOTION_CTA_ROUTES[variant]);
		}
		onClose();
	};

	return (
		<div className={styles.container} onClick={handleClick}>
			<CdnImg
				src={WE88_SEASONAL_PROMOTION_IMAGE_PATHS[variant]}
				width={288}
				height={360}
				alt={WE88_SEASONAL_PROMOTION_ALT_TEXT[variant]}
				isGalaxyFolder={true}
			/>
		</div>
	);
};
